import { memo, useCallback } from "react";

import { TablescapeContext, TablescapeEvent } from "@tablescape/context";
import { PageModal } from "@tablescape/state";

import { UGCVideoCarouselSlideView } from "./UGCVideoCarouselSlide.view";

type Props = {
  text: {
    playVideoModal: string;
  };
  video: {
    posterImage?: string;
    sources: { mimeType: string; url: string }[];
    subtitles?: string;
    title: string;
  };
};

const UGCVideoCarouselSlideBase = ({ text, video }: Props) => {
  const handleModalButtonClick = useCallback(() => {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_PAGE_MODAL, {
      ui: {
        pageModalTarget: PageModal.VIDEO_MODAL,
      },
      videoModal: {
        sources: video.sources,
        subtitles: video.subtitles,
      },
    });
  }, [video.sources, video.subtitles]);
  return (
    <UGCVideoCarouselSlideView
      handleModalButtonClick={handleModalButtonClick}
      text={text}
      video={video}
    />
  );
};

export const UGCVideoCarouselSlide = memo(UGCVideoCarouselSlideBase);
